module.exports = __webpack_public_path__ + "static/media/pin_on_icon.4a325f90.svg";